"use strict";

exports.__esModule = true;
exports.MetricDataTableController = MetricDataTableController;
var _react = _interopRequireDefault(require("react"));
var _RestAPI = require("../../API/RestAPI");
var _pivotByTime = require("./pivotByTime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function MetricDataTableController(props) {
  var _query$metrics;
  var query = props.query,
    shouldPivot = props.pivotByTime,
    columns = props.columns,
    excludeZeroValues = props.excludeZeroValues,
    children = props.children;
  var getTimeAggregateField = function getTimeAggregateField() {
    return query && query.bins.find(function (x) {
      return x.binName === "by_hour";
    }) ? "hour" : "workday";
  };
  var options = _react["default"].useMemo(function () {
    return {
      method: "POST",
      body: query
    };
  }, [query]);
  var formatDataProps = {
    shouldFormat: shouldPivot,
    formatFn: (0, _pivotByTime.pivotByTime)({
      metrics: query ? query.metrics : [],
      timeAggregateField: getTimeAggregateField(),
      columns: columns,
      excludeZeroValues: excludeZeroValues
    })
  };
  var _useRestApi = (0, _RestAPI.useRestApi)({
      url: "/api/v3/timeseries-metrics/flattened",
      options: options,
      formatDataProps: formatDataProps,
      shouldSendRequest: (query == null || (_query$metrics = query.metrics) == null ? void 0 : _query$metrics.length) > 0
    }),
    loading = _useRestApi.loading,
    data = _useRestApi.data,
    reload = _useRestApi.reload;
  return children({
    loading: loading,
    data: data,
    reload: reload
  });
}